import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { Presentation } from "../../core/gameflow/controller/Presentation";
import { GameData } from "../server/data/GameData";
import { SanQuentin2 } from "../SanQuentin2";
import { StateHandler } from "../../core/utils/StateHandler";
import { SanGameMode } from "../config/base/GameConfig";
import { GameSetting } from "../../core/setting/GameSetting";
import { SanEngineManager } from "../engine/SanEngineManager";
import { RevealerManager } from "../modules/revealer/RevealerManager";
import { IntroPresentation } from "../presentations/features/intro/IntroPresentation";

enum ZeroPresentationState {
    PICK_CLICK = "PICK_CLICK",
    DELAY = "DELAY",
    PICKED_GAMBLE = "PICKED_GAMBLE",
    FINISHED = "FINISHED",
}

export class ZeroBetPresentation extends Presentation {

    protected playIntroRestore: boolean = false;

    protected _gameData:GameData;

    private state: StateHandler = new StateHandler(undefined, new Map<String, Function >([
        [ZeroPresentationState.PICK_CLICK, (s:any) => this.ShowClickWindow()],
        [ZeroPresentationState.DELAY, () => this.onDelay()],
        [ZeroPresentationState.PICKED_GAMBLE, () => this.playerPickedGamble()],
        [ZeroPresentationState.FINISHED, () => this.onFinished()]
    ]));

    private ammFSLeft:number = 0;
    public static pickedZeroValue:number = 0;
    private isSetup:boolean;
    private isNormal:boolean;

    setInitData(data: GameData): void {
        this.setGameData(data);
    }

    setGameData(data: GameData): void {
        super.setGameData(data);
        this.ammFSLeft = data.raw.freespinsLeft - 1;

        this.isSetup = data.isFirstFSSetup;
        this.isNormal = data.isNormalMode;
        this.state.set((this.isSetup || this.isNormal) && data.nextMode != SanGameMode.FREESPIN_SETUP2 ? ZeroPresentationState.PICK_CLICK : ZeroPresentationState.FINISHED);
    }

    public preStart(): void {
        ZeroBetPresentation.pickedZeroValue = 1;
    }

    public createPresentation(enableSkip: Function) {
        enableSkip(false);
        this.state.triggerState(enableSkip);
    }

    playerPickedGamble() {
        this.timeline.add(SanQuentin2.setupPhase.ClickedGamble());
        this.setPlayable(false);
    }

    onDelay():void{
        this.timeline.to(this,{duration:0.25});
        this.state.set(ZeroPresentationState.PICKED_GAMBLE);
    }

    onFinished():void{
        this.timeline.to(this,{duration:0.1});
        this.setPlayable(false);
    }

    ShowClickWindow(): void {
        SanQuentin2.setupPhase.playClickable((picked:number) => {
            ZeroBetPresentation.pickedZeroValue = GameSetting.replayMode ? this._gameData.raw.playerSelect : picked;
            this.state.set(picked == 2 ? ZeroPresentationState.DELAY : ZeroPresentationState.FINISHED);
            SanQuentin2.setupPhase.disableClickAble();
            this.skip();
        })

        if(GameSetting.replayMode){
            SanQuentin2.setupPhase.restoreClicker(parseInt(this._gameData.raw.nextPlayerInteraction.selectedIndex));
            ZeroBetPresentation.pickedZeroValue = parseInt(this._gameData.raw.nextPlayerInteraction.selectedIndex);
            this.state.set(ZeroBetPresentation.pickedZeroValue == 2 ? ZeroPresentationState.DELAY : ZeroPresentationState.FINISHED);
        }else
            this.timeline.to(this,{ duration: 1, repeat: -1 });
    }

    done(): void {
        Logger.logDev("Sending ZeroBet");

        if(this.isSetup || this.isNormal){
            SanQuentin2.apiPlugin.betHandler.pickAndClickBet(ZeroBetPresentation.pickedZeroValue, false); //  1 / 2
        }
        else{
            SanQuentin2.postCounter.setAmount(this.ammFSLeft);
            SlotGame.keypadPlugin.setZeroBetSpinCounter(this.ammFSLeft);
            SlotGame.apiPlugin.betHandler.zeroBet();
        }
    }
}